export enum LoginType {
    LOGIN = 1145,
    ACCESS_CONTROL_LOGIN = 3454,
    HOSPITALITY_LOGIN = 5675,
    SKYACCESS_LOGIN = 7634,
    FREELEX_LOGIN = 5545,
    HEALTH_CARE = 6780,
    HOME_MONITORING = 7762,
    GREEN_BUILDING = 2778,
    PARKING = 3013,
    TIME_ATTENDANCE = 9981,
    EVENT_TICKETING = 4099
}